export default __webpack_public_path__ + "f17ba438d62d230db8a1b98b265ca397.png";